import { render, staticRenderFns } from "./memberDetails.vue?vue&type=template&id=3d232a65&scoped=true"
import script from "./memberDetails.vue?vue&type=script&lang=js"
export * from "./memberDetails.vue?vue&type=script&lang=js"
import style0 from "./memberDetails.vue?vue&type=style&index=0&id=3d232a65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d232a65",
  null
  
)

export default component.exports